module.exports = __webpack_public_path__ + "img/ساده.fcb80dc9.png";